export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";